import styled from 'styled-components';
var BackOption = styled.a.withConfig({
  displayName: "NavBack__BackOption",
  componentId: "sc-1av6l26-0"
})(["position:relative;flex-shrink:0;padding:18px 30px 18px 28px;padding:", ";margin-right:15px;color:", ";&:after{position:absolute;top:18px;bottom:18px;right:0;border-right:1px solid ", ";content:'';}&:hover{color:", ";}svg{position:absolute;top:20px;left:-2px;}"], function (_ref) {
  var datanobackicon = _ref.datanobackicon;
  return datanobackicon === 'true' ? "18px 30px 18px 28px" : "18px 30px 18px 0";
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.font;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mainColor;
});
export { BackOption as NavBack };